import React from "react";
import './Footer.component.scss'
import {animateScroll, scroller} from "react-scroll";
export default function Footer() {
    return (
        <footer className={"footer"}>
            <div className="column first">
                Book <span className="sized_text">your experience</span>
                <p>Ready to start your engines? Let us know your schedule and destination, and we’ll take care of the rest.</p>
                <button className="book_button" onClick={() => scroller.scrollTo("chooser", {delay: '100', duration: '1500', smooth: true})}>Book now</button>
            </div>
            <div className="column">
                <h2>legal information:</h2>
                <p>Flights performed under Jonair Affärsflyg AB AOC SE.aoc.0046 Operator’s terms and conditions apply.
                </p>
                <a href="https://jonair.se/en/villkor-affarsflyg/">Terms & conditions charter flight </a>
            </div>
            <div className="column">
                <h2>contact details:</h2>
                <p>
                    FRAM TRADE AND LOGISTICS OÜ <br/>

                    Harju maakond, Tallinn, <br/>

                    Kesklinna linnaosa, <br/>

                    Vesivärava tn 50-201, 10152 <br/>

                    Tel.: +000 00 000 00 00 <br/>

                    email: info@fram.ee

                </p>
            </div>
        </footer>
    )

}